export const NAME = 'casesContract';